export const HINT = [
  'Noun',
  'Adverb',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Adjective',
  'Noun',
  'Noun',
  'Adverb',
  'Adjective',
  'Adjective',
  'Noun',
  'Adjective',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Adjective',
  'Noun',
  'Adjective',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Adjective',
  'Adjective, noun',
  'Pronoun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Adjective',
  'Adjective',
  'Noun',
  'Adverb',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Pronoun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Verb: yo form',
  'Adjective',
  'Verb: él, ella, usted form',
  'Noun',
  'Noun',
  'Noun',
  'Verb: él, ella, usted form',
  'Verb: él, ella, usted form',
  'Noun',
  'Adjective',
  'Adjective, noun',
  'Noun',
  'Adjective, adverb',
  'Verb: ellos, ellas, ustedes form',
  'Adjective, adverb',
  'Noun',
  'Verb: él, ella, usted form',
  'Preposition, adverb',
  'Verb: yo form',
  'Noun',
  'Noun',
  'Adjective',
  'Verb: tú form ',
  'Noun',
  'Adjective, noun',
  'Verb in infinitive',
  'Verb: ellos, ellas, ustedes form',
  'Noun',
  'Verb: ellos, ellas, ustedes form',
  'Adjective, adverb, noun',
  'Adjective',
  'Adjective, noun',
  'Verb: ellos, ellas, ustedes form',
  'Adjective, noun',
  'Noun',
  'Verb in infinitive',
  'Verb: él, ella, usted form',
  'Noun',
  'Verb: yo form',
  'Verb in infinitive',
  'Noun',
  'Noun',
  'Noun',
  'Verb: ellos, ellas, ustedes form',
  'Verb in infinitive',
  'Noun',
  'Noun',
  'Verb: nosotros/as form',
  'Verb in infinitive',
  'Noun',
  'Verb in infinitive',
  'Pronoun',
  'Verb yo form',
  'Noun',
  'Noun',
  'Noun',
  'Verb: ellos, ellas, ustedes form',
  'Noun',
  'Adjective',
  'Noun',
  'Noun',
  'Verb in infinitive',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Verb in infinitive',
  'Pronoun',
  'Adjective',
  'Adjective',
  'Adjective, adverb',
  'Adjective',
  'Noun',
  'Noun',
  'Noun',
  'Preposition',
  'Adjective',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Verb in infinitive',
  'Noun',
  'Verb: nosotros/as form',
  'Adverb, noun',
  'Noun',
  'Verb in infinitive',
  'Adjective',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Adjective',
  'Verb in infinitive',
  'Noun',
  'Verb: él, ella, usted form',
  'Adverb',
  'Noun',
  'Adverb, conjunction',
  'Adjective',
  'Noun',
  'Noun',
  'Adjective',
  'Verb: nosotros/as form',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Adjective',
  'Noun',
  'Verb: ellos, ellas, ustedes form',
  'Noun',
  'Noun',
  'Noun',
  'Verb: nosotros/as form',
  'Noun',
  'Verb: él, ella, usted form',
  'Adjective',
  'Adjective, adverb',
  'Noun',
  'Adjective, noun',
  'Noun',
  'Noun',
  'Adjective',
  'Noun',
  'Noun',
  'Noun',
  'Verb: él, ella, usted form',
  'Noun',
  'Adjective',
  'Noun',
  'Noun',
  'Noun',
  'Verb: él, ella, usted form',
  'Noun',
  'Verb in infinitive',
  'Noun',
  'Noun',
  'Adjective',
  'Ordinal number',
  'Noun',
  'Verb: ellos, ellas, ustedes form',
  'Noun',
  'Verb: tú form ',
  'Noun',
  'Adjective',
  'Noun',
  'Noun',
  'Adjective',
  'Verb in infinitive',
  'Noun',
  'Noun',
  'Verb in infinitive',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Adjective',
  'Noun',
  'Noun',
  'Verb: él, ella, usted form',
  'Noun',
  'Verb in infinitive',
  'Adjective',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Verb in infinitive',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Verb: ellos, ellas, ustedes form',
  'Verb in infinitive',
  'Adjective',
  'Verb in infinitive',
  'Noun',
  'Adjective',
  'noun',
  'Verb: él, ella, usted form',
  'Noun',
  'Verb: él, ella, usted form',
  'Noun',
  'Verb: yo form',
  'Noun',
  'verb: él, ella, usted form',
  'Verb in infinitive',
  'Verb: yo form',
  'Adjective',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Verb: él, ella, usted form',
  'Adjective',
  'Noun',
  'Noun',
  'Adjective',
  'Verb in infinitive',
  'Noun',
  'Verb: yo form',
  'Adjective, noun',
  'Noun',
  'Noun',
  'Adjective',
  'Adjective',
  'Noun',
  'Verb: él, ella, usted form',
  'Noun',
  'Verb: él, ella, usted form',
  'Adjective, pronoun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Verb: él, ella, usted form',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Adjective, pronoun',
  'Noun',
  'Noun',
  'Adjective, pronoun',
  'Verb: él, ella, usted form',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Verb: yo form',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Verb: yo form',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Verb in infinitive',
  'Noun',
  'Adjective, adverb, preposition',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Adjective',
  'Noun',
  'Noun',
  'Verb in infinitive',
  'Noun',
  'Demonstrative adjective',
  'Noun',
  'Verb: ellos, ellas, ustedes form',
  'Verb in infinitive',
  'Noun',
  'Noun',
  'Noun',
  'Adjective',
  'Noun',
  'Verb in infinitive',
  'Noun',
  'Noun',
  'Adjective',
  'Noun',
  'Noun',
  'Adjective',
  'Noun',
  'Noun',
  'Verb in infinitive',
  'Noun',
  'Adjective',
  'Noun',
  'Noun',
  'Verb in infinitive',
  'Noun',
  'Noun',
  'Noun',
  'Noun',
  'Verb: él, ella, usted form',
  'Verb in infinitive',
  'Noun',
  'Verb in infinitive',
  'Verb: tú form',
  'Noun',
  'Adjective, Adverb, Interjection',
  'Verb: ellos, ellas, ustedes form',
  'Noun',
  'Verb in infinitive',
  'Noun',
  'Noun',
  'Adjective',
  'Noun',
  'Verb: yo form',
  'Noun',
  'Verb: él, ella, usted form',
  'Noun, adjective',
  'Noun',
  'Noun',
  'Verb in infinitive',
  'Noun',
]
